module.exports = __webpack_public_path__ + "img/ic-dropdown-injectable.4971958c.svg";